import { call, put, takeEvery } from "redux-saga/effects";
import { actionTypes as profileActionTypes } from "./reducer";
import {
  whoami as serviceGetProfile,
  getIncentive as getIncentiveService,
  getKnowledgeCenter as getKnowledgeCenterService,
  postKnowledgeCenterFavorite as postKnowledgeCenterFavoriteService,
  postIncentiveFavorite as postIncentiveFavoriteService,

  getKnowledgeCenterFolder as getKnowledgeCenterFolderService,
} from "./service";
import { message } from "antd";
import processAction from "../../utils/processAction";

function* getProfile(action) {
  try {
    const profile = yield call(serviceGetProfile);

    yield put({
      type: profileActionTypes.GET_PROFILE_REQUEST_SUCCESS,
      profile
    });
  } catch (err) {
    yield put({ type: profileActionTypes.GET_PROFILE_REQUEST_FAILED, err });

    message.error("Failed to get profile");
  }
}

//folder
function* getKnowledgeCenterFolder(action) {
  yield processAction({
    ...action,
    service: getKnowledgeCenterFolderService,
    success: profileActionTypes.GET_KNOWLEDGE_CENTER_FOLDER_SUCCESS,
    failed: profileActionTypes.GET_KNOWLEDGE_CENTER_FOLDER_FAILED,
  });
}

function* getIncentive(action) {
  yield processAction({
    ...action,
    service: getIncentiveService,
    success: profileActionTypes.GET_INCENTIVE_SUCCESS,
    failed: profileActionTypes.GET_INCENTIVE_FAILED
  });
}

function* getKnowledgeCenter(action) {
  yield processAction({
    ...action,
    service: getKnowledgeCenterService,
    success: profileActionTypes.GET_KNOWLEDGE_CENTER_SUCCESS,
    failed: profileActionTypes.GET_KNOWLEDGE_CENTER_FAILED
  });
}

function* postKnowledgeCenterFavorite(action) {
  const { params } = action;

  try {
    const payload = yield call(postKnowledgeCenterFavoriteService, params);
    yield put({
      type: profileActionTypes.POST_KNOWLEDGE_CENTER_SUCCESS,
      payload
    });
  } catch (error) {
    yield put({
      type: profileActionTypes.POST_KNOWLEDGE_CENTER_FAILED,
      error
    });
  }
}

function* postIncentiveFavorite(action) {
  const { params } = action;

  try {
    const payload = yield call(postIncentiveFavoriteService, params);
    yield put({
      type: profileActionTypes.POST_INCENTIVE_SUCCESS,
      payload
    });
  } catch (error) {
    yield put({
      type: profileActionTypes.POST_INCENTIVE_FAILED,
      error
    });
  }
}

function* watchGetProfileRequest() {
  yield takeEvery(profileActionTypes.GET_PROFILE_REQUEST, getProfile);
  yield takeEvery(profileActionTypes.GET_INCENTIVE, getIncentive);
  yield takeEvery(profileActionTypes.GET_KNOWLEDGE_CENTER, getKnowledgeCenter);
  yield takeEvery(
    profileActionTypes.POST_KNOWLEDGE_CENTER,
    postKnowledgeCenterFavorite
  );
  yield takeEvery(
    profileActionTypes.GET_KNOWLEDGE_CENTER_FOLDER,
    getKnowledgeCenterFolder
  );
  yield takeEvery(profileActionTypes.POST_INCENTIVE, postIncentiveFavorite);
}

export default [watchGetProfileRequest()];
